import { IChartContainer } from "../../models/base/chart-container.interface";
import { ChartStyleSettingsModel } from "../../models/chart-style/chart-style-settings.model";
import { AdvancedTradeComponent } from "../advanced-trade.component";
import { IComponent } from "../component.interface";
import { TradeComponent } from "../trade.component";

interface IAdvancedTradeOption {
    label: string;
    element: HTMLElement;
    value: string;
    visible: boolean;
    active: boolean;
}

export class AdvancedTradeIconComponent implements IComponent {
    public id = '';

    private element: HTMLElement;
    private dropdown: HTMLElement;
    private base: IChartContainer;
    private disabled = false;
    private options: IAdvancedTradeOption[] = [];
    private chartStyle: ChartStyleSettingsModel | null = null;
    private initDefaultOption = false;
    private selectedOption: IAdvancedTradeOption | null = null;

    constructor(element: HTMLElement, base: IChartContainer) {
        this.element = element;
        this.dropdown = this.element.findFirst('.avoep-dropdown');
        this.base = base;

        this.subscribeChartData();
        this.createOptions();
        this.onClick();
        this.onArrowWrapperClick();
        this.onBodyClick();
    }

    private subscribeChartData() {
        this.base.chartService.subscribeChartStyleData((chartStyle: ChartStyleSettingsModel) => {
            this.chartStyle = chartStyle;

            this.handleLiveData();
            this.initDefault();
        });
    }

    private initDefault() {
        if (this.initDefaultOption) {
            return;
        }

        this.initDefaultOption = true;
        if (!this.chartStyle?.advancedOEPEnabled || !this.chartStyle?.advancedOEPSupported) {
            this.element.addClass('hidden');

            const opt = this.options.find(o => o.value === 'advanced');
            if (opt) {
                opt.element.addClass('hidden');
                opt.visible = false;
            }

            return;
        }

        this.element.removeClass('hidden');
        
        if (this.disabled) {
            return;
        }

        if (this.chartStyle?.advancedOEPBasicTradeButtonText) {
            const basicOption = this.options.find(o => o.value === 'basic');
            if (basicOption) {
                basicOption.label = this.chartStyle.advancedOEPBasicTradeButtonText;
                basicOption.element.setInnerHtml(basicOption.label);
            }
        }

        if (this.chartStyle?.advancedOEPAdvancedTradeButtonText) {
            const advancedOption = this.options.find(o => o.value === 'advanced');
            if (advancedOption) {
                advancedOption.label = this.chartStyle.advancedOEPAdvancedTradeButtonText;
                advancedOption.element.setInnerHtml(advancedOption.label);
            }
        }

        let defaultOptionValue = 'basic';
        if (this.chartStyle?.advancedOEPStateModel?.defaultTradeMenu) {
            defaultOptionValue = this.chartStyle.advancedOEPStateModel.defaultTradeMenu;
        }

        if (this.chartStyle?.advancedOEPOpen) {
            defaultOptionValue = 'advanced';
        } else if (this.chartStyle?.newTradeUIOpen) {
            defaultOptionValue = 'basic';
        }
        
        let defaultOption = this.options.find(o => o.value === defaultOptionValue && o.visible);
        if (!defaultOption) {
            defaultOption = this.options.find(o => o.visible);
        }

        this.setActiveOption(defaultOption);
    }

    private setActiveOption(option: IAdvancedTradeOption) {
        this.options.forEach(o => {
            o.active = false;
            o.element.removeClass('active');
        });

        option.active = true;
        option.element.addClass('active');

        this.selectedOption = option;
        this.element.setAttribute('title', option.label);
        this.element.findFirst('button')?.setInnerHtml(option.label);
    }

    private handleLiveData() {
        if (!this.base.isDemo) return;

        this.disabled = true;
        this.element.setAttribute('title', 'Change to Live Data to trade from the web');
        this.element.addClass('disabled');
        this.element.findFirst('button')?.setAttribute('disabled', 'disabled');
    }

    private createOptions() {
        this.dropdown?.querySelectorAll<HTMLElement>('.avoep-option').forEach((optionElement: HTMLElement) => {
            const value = optionElement.getAttribute('data-value') || '';
            const label = optionElement.innerText || '';
            const option = { label, element: optionElement, value, visible: true, active: false };
            optionElement.addEventListener('click', () => {
                if (this.disabled) return;
                this.setActiveOption(option);

                this.removeAllActiveSelectList();

                const component = this.base.getComponentsByType(AdvancedTradeComponent)[0] as AdvancedTradeComponent;
                component.saveTradeMenuState(option.value);
            });

            this.options.push(option);
        });
    }

    private onClick() {
        this.element?.findFirst('button')?.addEventListener('click', () => {
            if (this.disabled) return;

            const advancedTradeComponent = this.base.getComponentsByType(AdvancedTradeComponent)[0] as AdvancedTradeComponent;
            const tradeComponent = this.base.getComponentsByType(TradeComponent)[0] as TradeComponent;
            if (this.selectedOption?.value === 'basic') {
                if (tradeComponent) {
                    if (tradeComponent.isActive()) {
                        tradeComponent.hide();
                    } else {
                        advancedTradeComponent?.hide();
                        tradeComponent.show();
                    }
                }
            } else if (this.selectedOption?.value === 'advanced') {
                if (advancedTradeComponent) {
                    if (advancedTradeComponent.isActive()) {
                        advancedTradeComponent.hide();
                    } else {
                        tradeComponent?.hide();
                        advancedTradeComponent.show();
                    }
                }
            }
        });
    }

    private onArrowWrapperClick() {
        this.element.findFirst('.arrow-wrapper')?.addEventListener('click', (e: any) => {
            e.preventDefault();
            e.stopPropagation();

            this.dropdown?.classList.toggle('active');
        });
    }

    private removeAllActiveSelectList() {
        this.dropdown?.removeClass('active');
    }
    
    private onBodyClick() {
        document.body.addEventListener('click', (e: any) => {
            if (!e || !e.target || typeof e.target.classList === 'undefined') {
                return;
            }

            if (!(e.target.classList.contains('avoep-dropdown') || !!e.target.closest('.avoep-dropdown'))) {
                this.removeAllActiveSelectList();
            }
        });
    }
}